import { render, staticRenderFns } from "./ClientStat.vue?vue&type=template&id=6da02b04&scoped=true"
import script from "./ClientStat.vue?vue&type=script&lang=js"
export * from "./ClientStat.vue?vue&type=script&lang=js"
import style0 from "./ClientStat.vue?vue&type=style&index=0&id=6da02b04&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da02b04",
  null
  
)

export default component.exports